import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import moment from 'moment';

import { UnidataTable } from '~/components';
import { number } from '~/helpers';
import {
  findOperacaoPreRecebimentoLista,
  recordFiltering,
} from '~/store/modules/operacaoprerecebimentolista/actions';

import { format, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';

function OperacaoPreRecebimento() {
  const operacaoprerecebimentolista = useSelector(
    (state) => state.operacaoprerecebimentolista
  );

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'prre_codigo',
        label: 'Recebimento Provisório',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'prre_data_cadastro',
        label: 'Data Registro',
        formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
      {
        id: 'prre_data_inicio',
        label: 'Início Recebimento',
        formatted: (value) =>
          value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
        align: 'center',
      },
      {
        id: 'prre_data_fim',
        label: 'Fim Recebimento',
        formatted: (value) =>
          value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
        align: 'center',
      },
      {
        id: 'prri_nf',
        label: 'Nota Fiscal',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'orga_nome',
        label: 'Órgão',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'prod_display',
        label: 'Produto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'prri_volume_nf',
        label: 'Volume',
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'prre_login_cadastro',
        label: 'Login Cadastro',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'prre_status_str',
        label: 'Status',
        filter: {
          type: 'text',
        },
        align: 'left',
      },

      {
        id: 'prre_cosi_contratogta',
        label: 'Contrato nº',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'prre_num_ano_empenho',
        label: 'Nº/Ano do Empenho',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'usua_login_recebedor_responsavel_str',
        label: 'Recebedor Responsável',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
    ],
    []
  );

  const filter = useMemo(
    () => [
      {
        id: 'data_cadastro_ini',
        label: 'Data Inicial',
        type: 'initialdatetime',
        defaultValue: datahorainicial,
      },
      {
        id: 'data_cadastro_fim',
        label: 'Data final',
        type: 'finaldatetime',
        defaultValue: datahorafinal,
      },
    ],
    [datahorainicial, datahorafinal]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="prre_codigo ASC"
        create={false}
        delete={false}
        update={false}
        fixed
        custom={filter}
        header={header}
        find={findOperacaoPreRecebimentoLista}
        redux={operacaoprerecebimentolista}
        read={recordFiltering}
        detach="prri_nf"
        keys={['prri_nf']}
        view="VW_PRE_RECEBIMENTO_ITEM"
        reportTitle="Recebimento Provisório Lista"
      />
    </>
  );
}

export default OperacaoPreRecebimento;
